import React from 'react';
import { Link } from 'react-router-dom'
import Project from '../../../api/project'
import Bg from '../../../images/backgrounds/bg_image_2.webp'
import Bg2 from '../../../images/shapes/shape_bg_1.webp'
import Bg3 from '../../../images/shapes/shape_title_under_line.svg'
import about1 from '../../../images/about/about_image_6.webp'
import aIcon1 from '../../../images/avatar/avatar_1.webp'
import aIcon2 from '../../../images/avatar/avatar_2.webp'
import aIcon3 from '../../../images/avatar/avatar_3.webp'
import aIcon4 from '../../../images/icons/icon_global.svg'
import aIcon5 from '../../../images/shapes/shape_line.webp'
import shape1 from '../../../images/shapes/shape_space_2.svg'

import logo from '../../../images/clients/logogram.png'
import logoLong from '../../../images/clients/logolong.png'
import ppa from '../../../images/clients/PPA_TABANG.png'
import omnia from '../../../images/clients/OMNIA.png'
import mml from '../../../images/clients/mml.png'
import Indosat from '../../../images/clients/Indosat.png'


const About = (props) => {

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  }

  return (
    <section className="about_and_case_section section_space section_decoration bg-dark" style={{ backgroundImage: `url(${Bg})` }}>
      <div className="container">
        <div className="row align-items-center justify-content-lg-between">
          <div className="col-lg-7 order-lg-last">
            <div className="about_image_2">
              <div className="image_wrap">
                <img src={logoLong} alt="Techco - About" />
              </div>
              <div className="about_funfact_info" style={{ backgroundImage: `url(${Bg2})` }}>
                <div className="customer_count">
                  <ul className="unordered_list">
                    <li>
                      <img src={ppa} alt="Customer Avatar" />
                    </li>
                    <li>
                      <img src={omnia} alt="Customer Avatar" />
                    </li>
                    <li>
                      <img src={Indosat} alt="Customer Avatar" />
                    </li>
                    <li>
                      <img src={mml} alt="Customer Avatar" />
                    </li>
                    <li>
                      <span>100+</span>
                    </li>
                  </ul>
                  <p className="mb-0">
                    Happy Customer
                  </p>
                </div>
                <div className="about_funfact_counter">
                  <div className="funfact_item">
                    <div className="counter_value">
                      <span className="odometer" data-count="6">800</span>
                      <span>+</span>
                    </div>
                    <h3 className="funfact_title mb-0">Projects Done</h3>
                  </div>
                  <div className="funfact_item">
                    <div className="counter_value">
                      <span className="odometer" data-count="100">99</span>
                      <span>%</span>
                    </div>
                    <h3 className="funfact_title mb-0">Results Guaranteed</h3>
                  </div>
                </div>
                <a className="btn btn-primary" href="/about">
                  <span className="btn_label" data-text="Learn More">Learn More</span>
                  <span className="btn_icon">
                    <i className="fa-solid fa-arrow-up-right"></i>
                  </span>
                </a>
                <div className="icon_globe">
                  <img src={aIcon4} alt="Icon Globe" />
                </div>
              </div>
              <div className="space_line">
                <img src={aIcon5} alt="Shape Line" />
              </div>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="about_content">
              <div className="heading_block mb-0 text-white">
                <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg3})` }}>
                  About Us
                </div>
                <h2 className="heading_text">
                  Panca Pilar <mark>Mission & Goal</mark>
                </h2>
                <p className="heading_description mb-0">
                  Supported by a team of certified professionals and an established client base across diverse business sectors including Oil and Gas, Mining, Exploration, Banking & Finance, Manufacturing, Government, Telecommunication Operators, ISPs, and many more. PPL has transformed into a highly experienced service integrator. We deliver a comprehensive range of solutions and competencies essential for driving industrial digitalization.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-170">
          <div className="heading_block text-center text-white">
            <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg3})` }}>
              Latest Project
            </div>
            <h2 className="heading_text mb-0">
              Our latest <mark>Project</mark>
            </h2>
          </div>

          {/* 👇 CSS BERINGAS ANTI-POTONG & ANTI-ILANG BRAY 👇 */}
          <style>{`
            @media (max-width: 991px) {
              .case_studies_wrapper {
                display: flex !important;
                flex-direction: column !important;
                gap: 40px !important; /* Jarak antar project */
              }
              .case_study_block {
                position: relative !important;
                display: flex !important;
                flex-direction: column !important;
                height: auto !important;
                overflow: visible !important; /* Copot alat pancung */
              }
              /* Atur gambar biar gak error di layar kecil */
              .case_study_block .case_study_image {
                position: relative !important;
                width: 100% !important;
                height: auto !important;
                display: block !important;
              }
              .case_study_block .case_study_image img {
                width: 100% !important; /* Timpa paksa angka 400px */
                height: auto !important; /* Timpa paksa angka 500px */
                max-height: 250px !important;
                object-fit: cover !important;
                border-radius: 10px 10px 0 0 !important;
                display: block !important;
              }
              /* Atur kotak putih teks biar nempel di bawah gambar */
              .case_study_block .case_study_content {
                position: relative !important;
                top: auto !important;
                bottom: auto !important;
                left: auto !important;
                right: auto !important;
                transform: none !important;
                width: 100% !important;
                height: auto !important;
                max-height: none !important;
                overflow: visible !important; /* Copot alat pancung 2 */
                margin: 0 !important;
                padding: 30px 20px !important;
                background: #ffffff !important;
                border-radius: 0 0 10px 10px !important;
                box-shadow: 0 10px 30px rgba(0,0,0,0.1) !important;
                z-index: 2 !important;
              }
            }
          `}</style>

          <div className="case_studies_wrapper">
            {Project.slice(6, 9).map((project, prj) => (
              <div className="case_study_block" key={prj}>
                <div className="case_study_image">
                  <img src={project.pImg} alt="Techco - Cases" style={{ width: 400, height: 500 }} />
                </div>
                <div className="case_study_content">
                  <ul className="category_list unordered_list text-uppercase">
                    <li><a href="">{project.sub}</a></li>
                  </ul>
                  <h3 className="case_title">
                    <Link onClick={ClickHandler} to={`/`}>{project.title}</Link>
                  </h3>
                  <p style={{ textAlign: 'justify' }}>
                    {project.description}
                  </p>
                  <ul className="icon_list unordered_list">
                    <li>
                      <span className="icon_list_text">
                        <strong className="text-dark">Industry:</strong> {project.Industry}
                      </span>
                    </li>
                    <li>
                      <span className="icon_list_text">
                        <strong className="text-dark">Country:</strong> {project.Country}
                      </span>
                    </li>
                  </ul>
                  {/* <ul className="case_technologies unordered_list" data-text="Core Technologies:">
                    <li>
                      <img src={project.Technologies1} alt="Angular" />
                    </li>
                    <li>
                      <img src={project.Technologies2} alt="Elephent" />
                    </li>
                  </ul> */}
                  {/* <Link onClick={ClickHandler} to={`/portfolio_details/${project.slug}`} className="btn btn-primary">
                    <span className="btn_label" data-text="Read Case">Read Case</span>
                    <span className="btn_icon">
                      <i className="fa-solid fa-arrow-up-right"></i>
                    </span>
                  </Link> */}
                </div>
              </div>
            ))}
          </div>

          {/* <div className="btns_group pb-0">
            <Link onClick={ClickHandler} to="/portfolio" className="btn btn-primary">
              <span className="btn_label" data-text="View More Cases Study">View More Cases Study</span>
              <span className="btn_icon">
                <i className="fa-solid fa-arrow-up-right"></i>
              </span>
            </Link>
          </div> */}
        </div>
      </div>
      <div className="decoration_item shape_image_1">
        <img src={shape1} alt="Techco Shape" />
      </div>
    </section>
  )
}

export default About;
